import React from "react";
import Carousel from "react-elastic-carousel";
import { Col } from "react-bootstrap";

import RoundBlueCharacter from "../../../assets/images/RoundBlue-Character 1.png"

const DashboardCarousel = () => {

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];
  return (
    <>
      <Col xs={12}>
        <span className="dashbboard-help-section-heading">Help</span>
      </Col>
      <Col xs={12} style={{paddingRight:"10px"}}>
        <Carousel breakPoints={breakPoints} className="dashbboard-help-section-carousel">
          <div ><span className="dashboard-help-cards speed-marking-help">
            <span className="dashboard-help-cards-text">Speed marking:</span>
            <span className="dashboard-help-cards-subtext">Be quicker and more accurate</span>
          </span>
          </div>
          <div ><span className="dashboard-help-cards report-help">
            <span className="dashboard-help-cards-text">We’ve written your reports!</span>
            <span className="dashboard-help-cards-subtext">How to personalise them</span>
          </span>
          </div>
          <div ><span className="dashboard-help-cards moderate-writing-help">
            <span className="dashboard-help-cards-text">Moderate writing</span>
            <span className="dashboard-help-cards-subtext">in a couple of clicks!</span>
          </span>
          </div>
        </Carousel>
        <div className="d-flex justify-content-end position-relative" style={{ marginTop: "-160px" }} defer><img src={RoundBlueCharacter} alt="" defer/></div>
      </Col>
    </>

  )
}

export { DashboardCarousel }